import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { initStoreAndServices } from '../../config';
import { ReviewsContextProvider } from '../shared/context';
import ReviewsCarousel from './ReviewsCarousel';

/**
 * @type {React.FC<{
 *  initialState: any;
 *  carouselMaxLines?: number;
 *  translationUrl: string;
 * }>}
 */
const ReviewsCarouselEntry = ({ initialState, carouselMaxLines = 2, translationUrl }) => {
    const store = initStoreAndServices(initialState);
    return (
        <Provider store={store}>
            <ReviewsContextProvider translationUrl={translationUrl}>
                <ReviewsCarousel maxLines={carouselMaxLines} />
            </ReviewsContextProvider>
        </Provider>
    );
};

ReviewsCarouselEntry.propTypes = {
    initialState: PropTypes.object,
    carouselMaxLines: PropTypes.number,
    translationUrl: PropTypes.string,
};

export default ReviewsCarouselEntry;
